import { Http } from './Http';
import {
  AuthClient,
  NotificationClient,
  RevisionClient,
  MediaClient,
  MediaLinkClient,
  SocialAuthClient,
  SubscriptionAssignmentClient,
  SocialMediaClient,
  ScriptClient,
  UserMemoryClient,
  LongTermMemoryClient,
  AiAgentClient,
} from './services';

const http = new Http();

const Api = {
  auth: new AuthClient(http),
  revision: new RevisionClient(http),
  notification: new NotificationClient(http),
  media: new MediaClient(http),
  sharedMedia: new MediaLinkClient(http),
  socialAuth: new SocialAuthClient(http),
  subscriptionAssignment: new SubscriptionAssignmentClient(http),
  socialMedia: new SocialMediaClient(http),
  script: new ScriptClient(http),
  userMemory: new UserMemoryClient(http),
  longTermMemory: new LongTermMemoryClient(http),
  aiAgent: new AiAgentClient(http),
  http,
};

export { http as Http, Api };
